var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHpClothNormal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_2",
    "data-name": "\\u56FE\\u5C42 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_1-2",
    "data-name": "\\u56FE\\u5C42 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M763.59,125.8,646.79,67.4a32.31,32.31,0,0,0-14.3-3.4H199.59a32,32,0,0,0-14.3,3.4L68.49,125.8a8,8,0,0,0-4.4,7.2V312a8,8,0,0,0,8,8h120V632a8,8,0,0,0,8,8H432l24-64H256.09V256h-128V167.5l79.1-39.5H625l79.09,39.5V256h-128V480h64V320h120a8,8,0,0,0,8-8V132.9A8.17,8.17,0,0,0,763.59,125.8Z",
    style: {
      fill: "#96a2b1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M819.89,448H460a16.05,16.05,0,0,0-15.4,11.6L323.89,882.2a16,16,0,0,0,9.5,19.3,832.44,832.44,0,0,0,613.1,0,15.94,15.94,0,0,0,9.5-19.3L835.29,459.6A15.87,15.87,0,0,0,819.89,448ZM478,576l18.3-64h287.4L802,576ZM640,896a764.66,764.66,0,0,1-165.1-18,773.88,773.88,0,0,1-77.2-21.2L459.59,640h360.6l61.9,216.8a765,765,0,0,1-121.4,29.6A763.4,763.4,0,0,1,640,896Z",
    style: {
      fill: "#5b6673"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416,256A128.12,128.12,0,0,1,288,128h64a64,64,0,0,0,128,0h64A128.12,128.12,0,0,1,416,256Z",
    style: {
      fill: "#96a2b1"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1024,
    height: 1024,
    style: {
      fill: "none"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHpClothNormal);
export default __webpack_public_path__ + "static/media/hp_cloth_normal.b4892bf6b5614c02245cfadde04f6c73.svg";
export { ForwardRef as ReactComponent };